import React from 'react';
import { Navigate } from 'react-router-dom';
import DiscordFloatingWidget from './DiscordFloatingWidget';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('sessionToken');
  
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <>
      {children}
      <DiscordFloatingWidget />
    </>
  );
}

export default ProtectedRoute;
